import React from 'react';
import { Flex, Heading, Text, Box } from 'pounceV2';
import NotFoundImg from 'Assets/illustrations/not-found.svg';
import withSEO from 'Hoc/withSEO';
import { LinkButtonV3 } from 'Components/buttons/LinkButton/LinkButtonV3';
import { Permission } from 'Generated/schema';
import useCheckPermissions from 'Hooks/useCheckPermissions';

const Page404V3: React.FC = () => {
  const canUserAccessSummary = useCheckPermissions(Permission.SummaryRead);

  return (
    <Flex
      justify="center"
      align="center"
      direction="column"
      height="100%"
      width="100%"
      data-dd-privacy="allow"
    >
      <Box mb={10}>
        <img alt="Page not found illustration" src={NotFoundImg} width="auto" height={400} />
      </Box>
      <Heading variant="h2" fontWeight="medium" mb={2}>
        Not all who wander are lost...
      </Heading>
      <Text mb={10}>( You definitely are though )</Text>
      {canUserAccessSummary && <LinkButtonV3 to="/">Back to Home</LinkButtonV3>}
    </Flex>
  );
};

export default withSEO({ title: 'Not Found' })(Page404V3);
